<template>
<v-container
    grid-list-xs
  >
    <v-card>
        <listSessions />
    </v-card>
  </v-container>
</template>

<script>
import listSessions from './listSessions.vue';

export default {
    components: {
        listSessions
    }
}
</script>

<style>

</style>